import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "@/components/ui/select";
import type { LeaderboardCycleWithSeason } from "@/hooks/useGetAllLeaderboardCycle";
import { format } from "date-fns";

type SelectCyclesProps = {
  selectedLeaderCycle: LeaderboardCycleWithSeason | undefined;
  setSelectedLeaderCycle: (leaderboardCycle: LeaderboardCycleWithSeason) => void;
  leaderboardCycles?: LeaderboardCycleWithSeason[];
};

export const SelectCycles = ({ selectedLeaderCycle, setSelectedLeaderCycle, leaderboardCycles }: SelectCyclesProps) => {
  const handleCycleChange = (value: string) => {
    const cycle = leaderboardCycles?.find((cycle) => cycle.id === value);
    if (cycle) setSelectedLeaderCycle(cycle);
  };

  const reversedCycles = leaderboardCycles ? [...leaderboardCycles].reverse() : [];

  if (!selectedLeaderCycle) return null;

  return (
    <Select value={selectedLeaderCycle.id} onValueChange={handleCycleChange}>
      <SelectTrigger
        className="max-w-fit border-secondary rounded-lg text-[#0098EA] font-semibold ring-0 focus:ring-0 text-center"
        iconClassName="opacity-100 text-secondary w-5 h-5"
      >
        <span className="w-full text-center px-1 text-xs font-bold flex justify-center items-center">
          {selectedLeaderCycle.name}
        </span>
      </SelectTrigger>

      <SelectContent className="rounded-lg">
        <SelectGroup>
          {reversedCycles?.map((cycle) => (
            <SelectItem key={cycle.id} value={cycle.id}>
              {cycle.name}
              <span className="text-gray-800 text-[12px] font-medium leading-[1] ml-1">
                {cycle?.startDate ? format(new Date(cycle.startDate), "yyyy/M/d") : ""}
                {cycle?.endDate ? ` - ${format(new Date(cycle.endDate), "yyyy/M/d")}` : ""}
              </span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
